/**
 * Feature gate matrix — defines the minimum subscription tier required for each feature.
 * Used by the FeatureGate component (client) and Cloud Functions (server).
 *
 * All tiers see 'ask-me-anything' but capability differs by tier
 * (basic vs advanced) — that branching lives in response.js, not here.
 */
export const FEATURE_GATES = {
  // ASK ME ANYTHING
  'ask-me-anything':        { minTier: 'free' },
  'upload-discuss-results': { minTier: 'large' },

  // SYMPTOM CHECKER
  'symptom-checker':        { minTier: 'free' },
  'symptom-voice':          { minTier: 'medium' },
  'symptom-cmr-in-flow':    { minTier: 'medium' },
  'symptom-diagnostic-tests': { minTier: 'medium' },

  // CMR
  'cmr':                    { minTier: 'free' },
  'cmr-share':              { minTier: 'free' },

  // MEDICATIONS
  'medications':            { minTier: 'free' },
  'medication-tracking':    { minTier: 'medium' },
  'update-my-medications':  { minTier: 'medium' },

  // FACILITY / VISIT
  'facility-visit':         { minTier: 'free' },

  // OTHER
  'data-links':             { minTier: 'medium' },
};

/**
 * Monthly usage caps enforced server-side.
 * 'Infinity' means unlimited.
 * ask-me-anything free tier uses a daily cap (5/day) instead of monthly.
 */
export const USAGE_CAPS = {
  'symptom-checker': {
    free: 1,
    small: 3,
    medium: 7,
    large: Infinity,
  },
  'ask-me-anything': {
    free: 5,       // per DAY, not per month
    small: 30,
    medium: 200,
    large: Infinity,
  },
};

/**
 * Whether the cap for a given feature+tier is per-day instead of per-month.
 */
export const USAGE_CAP_PERIOD = {
  'ask-me-anything': {
    free: 'day',
    small: 'month',
    medium: 'month',
    large: 'month',
  },
};
